import {
  Button,
  CloseButton,
  Divider,
  Group,
  SimpleGrid,
  Stack,
  Text,
  rem,
} from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import { useTranslations } from 'next-intl';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

export interface FavoriteDriverConfirmModalProps {
  supplierName: string;
  onConfirm: () => void;
}

export function FavoriteDriverConfirmModal({
  context,
  id,
  innerProps,
}: ContextModalProps<FavoriteDriverConfirmModalProps>) {
  const { supplierName, onConfirm } = innerProps;
  const t = useTranslations('record.favorite_driver');
  const isMobile = useIsMobile();

  const handleConfirm = () => {
    onConfirm();
    context.closeModal(id);
  };

  const handleCancel = () => {
    context.closeModal(id);
  };

  return (
    <>
      <Group
        justify="space-between"
        align="center"
        p={rem(16)}
        pb={isMobile ? 0 : rem(16)}
      >
        <Text
          flex={1}
          size="lg"
          fw={600}
          c="neutral.7"
          ta={isMobile ? 'center' : 'left'}
        >
          {t('remove_title')}
        </Text>

        {!isMobile ? (
          <CloseButton
            iconSize={rem(24)}
            variant="transparent"
            onClick={handleCancel}
            c="neutral.6"
          />
        ) : null}
      </Group>

      {!isMobile ? <Divider /> : null}

      <Stack gap={rem(24)} p={rem(16)}>
        <Text c="neutral.6" fw={500}>
          {t('remove_description', { supplierName })}
        </Text>
        <SimpleGrid cols={2}>
          <Button
            variant="light"
            onClick={handleCancel}
            bg="neutral.2"
            c="neutral.7"
            fw={600}
            size="lg"
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            bg="red.6"
            c="white"
            fw={600}
            size="lg"
          >
            {t('confirm_remove')}
          </Button>
        </SimpleGrid>
      </Stack>
    </>
  );
}
